export default "__VITE_ASSET__BzMOzJtn__"